import { render, staticRenderFns } from "./www-deepmedical-net-cn.vue?vue&type=template&id=3a63f8c0&scoped=true&"
var script = {}
import style0 from "./www-deepmedical-net-cn.vue?vue&type=style&index=0&id=3a63f8c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63f8c0",
  null
  
)

export default component.exports